module.exports = __webpack_public_path__ + "media/customizations/everbe/logo-2a9be228c2fcaaec730b2aae691eb82e.png";